import {createTheme} from "@mui/material";

export const customTheme = createTheme({
    palette: {
        success:{main: '#29CC97'},
        error:{main: '#F04B2F'},
        secondary: {main: '#9FA2B4'},
        text: {primary: '#2E2E2E', secondary: '#9FA2B4'}
    },
    typography: {
        fontFamily: "Mulish",
        h1: { fontSize: "1.5rem", fontWeight: "700", color: "#252733"},
        h2: { fontSize: "1.1875rem", fontWeight: "700", color: "#252733"},
        subtitle1: {fontSize: ".875rem"},
        h4: {fontSize: ".875rem", fontWeight: "500", color: "#252733"},
        body2: {fontSize: ".875rem"},
    },
    components: {
        MuiButton:{
            styleOverrides: {
                root: {
                    textTransform: "capitalize",
                    borderRadius: ".25rem",
                    fontWeight: "700",
                    padding: ".5625rem 1.5rem",
                    letterSpacing: ".02em",
                    boxShadow: "none",
                },
                contained: {
                    border: `.0625rem solid`,
                    '&:hover': {
                        boxShadow: "none",
                    },
                },
                containedError:{
                   borderColor: `#F04B2F`,
                    '&:hover': {
                        borderColor: `#a83420`,
                    },
                },
                containedSuccess:{
                    color: `#fff`,
                    borderColor: '#29CC97',
                    '&:hover': {
                        borderColor: `#1c8e69`,
                    },
                },
                outlinedSecondary:{
                    color: `#2E2E2E`,
                    '&:hover': {
                        borderColor: `#F04B2F`,
                        color: `#F04B2F`,
                        backgroundColor: `rgba(240, 75, 47, 0.1)`
                    },
                },
                sizeSmall: {
                    padding: ".375rem 1.5rem",
                    lineHeight: "1.43"
                },
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: ".5rem",
                    border: ".0625rem solid #DFE0EB",
                    boxShadow: "none"
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderColor: "#DFE0EB",
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    borderRadius: `.25rem`
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides:{
                root: {
                    borderRadius: `.25rem`
                }
            }
        },
        MuiInput: {

        }
    }
})